import React from 'react';
import { Section } from '../ui/Section';
import { Quote } from 'lucide-react';
export function Testimonial() {
  return <Section background="offwhite" data-id="element-155">
      <div className="max-w-4xl mx-auto text-center" data-id="element-156">
        <div className="flex justify-center mb-8" data-id="element-157">
          <Quote size={56} className="text-primary-gold" data-id="element-158" />
        </div>
        <blockquote className="text-2xl md:text-3xl font-playfair text-primary-deep-blue mb-8 italic" data-id="element-159">
          "The supplies from Farasha Medical Aid have transformed our ability to
          serve our community. We can now provide quality care to hundreds of
          patients each month who would otherwise have no access to medical
          treatment."
        </blockquote>
        <div className="text-center" data-id="element-160">
          <p className="font-playfair font-bold text-xl text-primary-deep-blue mb-1" data-id="element-161">
            Dr. Mina
          </p>
          <p className="font-inter text-neutral-charcoal" data-id="element-162">
            St. Mary's Monastery Clinic, Minya
          </p>
        </div>
      </div>
    </Section>;
}